























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import store from "@/store/store";
import moment from "moment";
import axios from "axios";
import SignatureEntry from "./SignatureEntry.vue";
import { loadParts } from "@/common/jobLoader";

@Component({
  components: {
    SignatureEntry,
  },
})
export default class IssueList extends Vue {
  @Prop() public customTitle: string;
  @Prop() public showDialog: boolean;
  @Prop({ default: [] })
  public issueList: string[];
  public internalShowDialog: boolean = false;

  // Watchers so that element dialog .sync works with a prop
  @Watch("showDialog")
  public updateInternal() {
    this.internalShowDialog = this.showDialog;
  }

  @Watch("internalShowDialog")
  public updateExternal() {
    if (!this.internalShowDialog) {
      this.$emit("issueListClosed");
    }
  }

  public closeDialog() {
    this.$emit("issueListClosed");
  }
}
